import Vue from 'vue';
import VModal from 'vue-js-modal';
import './app/Helpers/Helpers';
import toaster from 'vue-toastr';
import store from './store/client';

Vue.component('app-popular-categories', require('./client/PopularCategories').default);
Vue.component('app-loading', require('./core/components/preloders/Loader').default);
Vue.component('app-contact-us', require('./client/ContactUs').default);
Vue.component('app-product', require('./client/Product').default);
Vue.component('app-cart', require('./client/Cart').default);
Vue.component('app-cart-view', require('./client/CartView').default);
Vue.component('app-cart-item', require('./client/CartItem').default);
Vue.component('app-login', require('./client/Login').default);
Vue.component('app-no-data-found', require('./core/components/datatable/EmptyData').default);
Vue.component('app-billing-address', require('./client/BillingAddress').default);
Vue.component('app-order-details', require('./client/OrderDetails').default);
Vue.component('app-product-details', require('./client/ProductDetails').default);

import 'vue-select/dist/vue-select.css';

Vue.use(VModal);

Vue.use(toaster);
new Vue({
    el: '#client',
    store
});